import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { useJourneyType } from '@hooks/useJourneyType';
import { FEATURES_LIST } from '../../context/featureSwitch';

export const useIgnorePromoCode = () => {
    const { isCash } = useJourneyType();
    const isPxIgnorePromoFinance = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_PX_IGNORE_PROMO_FINANCE);
    const isPxIgnorePromoCash = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_PX_IGNORE_PROMO_CASH);

    if (isCash) {
        return isPxIgnorePromoCash;
    }
    return isPxIgnorePromoFinance;
};
